export default "__VITE_ASSET__BW23AiIj__"